import { useMemo, useState } from 'react';

import type { ImageAnalyses } from '../../../../@types/latestImagesV2';
import { PAGINATION_IMAGE_COUNT } from '../../../insuranceExport/constants';

export function useImagePagination(images: ImageAnalyses[] | undefined) {
  const [currentPage, setCurrentPage] = useState(0);

  const pageCount = useMemo(() => {
    if (!images || images.length === 0) return 1;
    return Math.ceil(images.length / PAGINATION_IMAGE_COUNT) + 1;
  }, [images]);

  const handlePageChange = (direction: 'prev' | 'next') => {
    if (direction === 'prev') {
      setCurrentPage((prev) => (prev > 0 ? prev - 1 : 0));
    } else {
      setCurrentPage((prev) =>
        prev < pageCount - 1 ? prev + 1 : pageCount - 1,
      );
    }
  };

  return {
    currentPage,
    pageCount,
    handlePageChange,
  };
}
